<template>
  <div class="step5">
    <vue-good-table
        :columns="columns"
        :rows="rows"
        :sort-options="{
           enabled: false
        }"
    >
      <template slot="table-row" slot-scope="props">
    <span v-if="props.column.field === 'qty'">
<!--      {{JSON.stringify(props.row)}}-->
      <input type="number" class="input-number" step="1" min="1" :max="props.row.available"
             @change="(e)=>someHandler(props.row.id,e.target)">
    </span>
        <span v-else>
      {{ props.formattedRow[props.column.field] }}
    </span>
      </template>
    </vue-good-table>
    <div class="button-con">
      <CButton color="green" text="Complete" @click="onNextClick"/>
      <div class="ml20">
        <CButton color="orange" text="Back" @click="onBack"/>
      </div>
      <div class="ml20">
        <CButton color="red" text="Cancel" @click="onCancel"/>
      </div>
    </div>
  </div>
</template>

<script>
import CButton from "../common/CButton.vue";
import { VueGoodTable } from 'vue-good-table';

var isAllocationValid = true;
export default {
  name: 'Steps4',
  components: {
    CButton,
    VueGoodTable
  },
  props: {
    orderData: Array,
    onNext: Function,
    onBack: Function,
    onCancel: Function,
  },
  data() {
    return {
      columns: [
        {
          label: 'Product Name',
          field: 'name',
          type: 'string',
        },
        {
          label: 'Qty Ordered',
          field: 'qtyOrdered',
          type: 'string',
        },
        {
          label: 'Allocated',
          field: 'allocated',
          type: 'number',
        },
        {
          label: 'Available',
          field: 'available',
          type: 'number',
        },
        {
          label: 'Qty',
          field: 'qty',
          type: 'number',
        },
      ],
      qty: {}
    }
  },
  computed: {
    rows(){
      return this.orderData.map((item,index)=>{
        return {
          id: index,
          itemId: item.id,
          name: item.title,
          qtyOrdered: item.qty,
          allocated: item.allocated ,
          available: item.remains,
          qty: 0
        }
      });
    }
  },
  mounted() {
    for(let i=0;i<this.orderData.length;i++){
      this.qty[''+this.orderData[i].id] = '0';
    }
  },
  methods: {
    onNextClick(){
      if (!this.isAllocationValid)
      {
        alert("Allocation quantity is not valid!");
      }
      else
      {
        this.onNext(this.qty);
      }
    },
    someHandler(index,target){
      target.value = Math.floor(target.value);
      if (Number(target.value)>this.orderData[index].remains){
        target.classList.add('error');
        this.isAllocationValid = false;
      }
      else if (Number(target.value) < 1)
      {
        target.classList.add('error');
        this.isAllocationValid = false;
      }
      else
      {
        target.classList.remove('error');
        this.isAllocationValid = true;
      }
      this.qty[''+this.orderData[index].id] = target.value;
    },
  }
}
</script>